<template>
    <eventi-view-component :jsonData="jsonData" :pathResource="pathResource" :pathResourceFirma="pathResourceFirma" :utente="utente" :titoloEvento="titoloEvento" :linkPrintData="linkPrintData">
        <template slot="tab-content-event">
            <ecodoppler-arti-inferiori-view-component :idEvento="id" @update="onUpdateJsonData"></ecodoppler-arti-inferiori-view-component>
        </template>
    </eventi-view-component>
</template>
<script>
import UtilityMixins from "../../../../../utility/UtilityMixin";
import EventiMixins from "../../../utility/mixins/EventiMixins";
import EcodopplerArtiInferioriViewComponent from "./EcodopplerArtiInferioriViewComponent.vue";
import EventiViewComponent from "../../../base/components/EventiViewComponent.vue";

export default {
    mixins: [UtilityMixins, EventiMixins],
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    components: { EcodopplerArtiInferioriViewComponent, EventiViewComponent },
    data() {
        return {
            linkback: null,
            linkedit: null,
            titoloEvento: "Ecodoppler Arti Inferiori",
            pathResource: "/cardioecodopplerartiinferiori",
            pathResourceFirma: "/cardioecodopplerartiinferiori",
            jsonData: {},
            id: null,
            showModalLoading: false,
            fontScale: 2,
            pathRestValidation: "/validation",
            isThisFirmato: false,
            linkPrintData: null,
        };
    },
    computed: {
        idPaziente() {
            return this.$route.query.idPaziente;
        },
        linkPatient() {
            return EventiMixins.getLinkPatient(this.utente, this.idPaziente);
        },
    },
    mounted() {
        let me = this;
        me.jsonData.idPaziente = this.$route.query.idPaziente;
        me.id = this.$route.params.id;
    },
    methods: {
        onFirmaUpdate() {
            let me = this;
            me.loadData();
        },
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
            me.linkPrintData = "/pazienteeventi/print/" + me.jsonData.id;
        },
    },
};
</script>
